import {DataContentWrapper} from '@hconnect/common/containers'
import {useUpmPlant} from '@hconnect/upm'
import {useTranslation} from 'react-i18next'

import {TaskDetailsCard, PlantActionDetails, MetaAnnotation} from '../../components'
import {FEATURE_NAMESPACE} from '../../consts'
import {usePomAction} from '../../hooks'
import {HProduceTaskIdentifiers, HProduceTask} from '../../types'

type Props = {
  task: HProduceTaskIdentifiers
  onClose: () => void
  timezone: string
}

export const PlantActionDetailsContainer = ({task, timezone, onClose}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {upmId} = useUpmPlant({plantId: task.plantId})
  const {data, isLoading, isError, refetch, isRefetching} = usePomAction({
    plantId: upmId,
    actionId: task.externalId
  })

  return (
    <DataContentWrapper
      data={data}
      showLoader={isLoading}
      isError={isError}
      retryFunction={refetch}
      isRefetching={isRefetching}
      noDataSettings={{
        noDataMessage: t('task.message.taskNotFound'),
        onActionClick: () => onClose()
      }}
    >
      {data && (
        <TaskDetailsCard
          item={{...task, title: data.title, created: data.createdAt} as HProduceTask}
          timezone={timezone}
          onClose={onClose}
          metaAnnotationSlot={
            <MetaAnnotation
              label={t('metaAnnotation.label.created')}
              date={data.createdAt}
              timezone={timezone}
              data-test-id="meta-annotation-created-on"
            />
          }
        >
          <PlantActionDetails action={data} timezone={timezone} />
        </TaskDetailsCard>
      )}
    </DataContentWrapper>
  )
}
